import { assignModule } from '@blocks/base/store';
import user from '@blocks/user/module';
import { inviteFriend } from '@this/services/user';
const state = {
  mid: 0,
  activity: '',
  cards: [],
  exchange: false,
};

const mutations = {
  setMID(state, str) {
    state.mid = str;
  },
  setActivity(state, str) {
    state.activity = str;
  },
  setCards(state, array) {
    state.cards = array;
  },
  setExchange(state, bool) {
    state.userInfo.exchange = bool;
  },
  calcUserChance(state, { type, field = 'chance' }) {
    switch (type) {
      case 'plus':
        state.userInfo[field] += 1;
        break;
      case 'minus':
        state.userInfo[field] -= 1;
        break;
      default:
        throw '操作不存在';
    }
  },
};

const actions = {
  // 事件
  authBefore({ dispatch }, to) {
    const {
      query: { mid, activity },
    } = to;
    dispatch('setValue', { key: 'mid', mutation: 'setMID', value: mid });
    dispatch('setValue', { key: 'activity', mutation: 'setActivity', value: activity });
  },
  async authAfter({ dispatch }) {
    await dispatch('config/getBrand', null, { root: true });
  },
  async authSuccess({ dispatch }) {
    await dispatch('getUserInfo');
    await dispatch('config/getBrand', null, { root: true });
  },
  inviteFriend({ state }) {
    const { mid, activity } = state;
    if (!mid || !activity) return;
    return inviteFriend({
      mid,
      activity,
    });
  },
};

export default assignModule(user, {
  state,
  mutations,
  actions,
});
